import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { FlexibleDiv } from '@components/formStyles';
import { OutlinkIcon } from '@assets/icons';
import { DistanceDetailWrapper } from '@components/ui/cards/ListingItem/next/styled';
import { HotelDistanceViewModel } from '@api/v3';

import { LocationLink, ShowInMapWrapper, Dots } from '../SummaryCardStyle';

const DistanceMapDesktop = ({
  distanceList,
  latitude,
  longitude,
  toggleMap,
}: {
  distanceList?: HotelDistanceViewModel[];
  latitude?: number;
  longitude?: number;
  toggleMap?: () => void;
}) => {
  return (
    <>
      {distanceList?.[0]?.distance ? (
        <DistanceDetailWrapper>
          <Dots />
          <Typography weight='SemiBold' variant='caption2' color='NL800'>
            {`${distanceList[0].name}`}{' '}
          </Typography>
          <Typography weight='SemiBold' variant='caption2' color='NL800'>
            merkez:{' '}
          </Typography>
          <Typography weight='Regular' color='NL800' variant='caption2'>
            {`${distanceList[0].distance
              .toLocaleString('tr-TR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 1,
              })
              ?.toString()
              .replace(',', '.')} km`}
          </Typography>
        </DistanceDetailWrapper>
      ) : null}

      {latitude && longitude ? (
        <ShowInMapWrapper>
          <LocationLink onClick={toggleMap}>· Haritada Gör</LocationLink>
          <FlexibleDiv>
            <CustomIcon fontSize={18} paletteColor='B300' icon={OutlinkIcon} />
          </FlexibleDiv>
        </ShowInMapWrapper>
      ) : null}
    </>
  );
};

export default DistanceMapDesktop;
